export default __webpack_public_path__ + "static/media/fb.19f290eb.svg";